import { PaymentMethod } from '@/features/dashboard/tourConfig/types/PaymentMethod.ts';
import { z } from 'zod';

export const createBookingSummarySchema = (requiredConsentIds: string[]) =>
  z.object({
    paymentMethod: z.enum(PaymentMethod),
    termsConsent: z
      .boolean({ error: 'Pole wymagane' })
      .refine((val) => val === true, {
        message: 'Musisz wyrazić zgodę, aby kontynuować',
      }),
    tourConsents: z
      .record(z.string(), z.boolean())
      .superRefine((consents, ctx) => {
        for (const consentId of requiredConsentIds) {
          if (!consents[consentId]) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              message: 'Musisz wyrazić zgodę, aby kontynuować',
              path: [consentId],
            });
          }
        }
      }),
  });

export const bookingSummarySchema = createBookingSummarySchema([]);

export type BookingSummaryInputForm = z.input<typeof bookingSummarySchema>;
export type BookingSummaryForm = z.infer<typeof bookingSummarySchema>;
